
import { AxiosResponse } from "axios";
import { useContext, useRef, useState } from "react";
import { toast } from "react-toastify";

import { Alert, Spinner } from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";
import GenericModal from "./GenericModal";

interface IParams {
  sourceType: string; // es: "archive"
  sourceId: number; //es: archiveId
  contentId: number;
  children: any;
  hasLoaderModal?: boolean;
  style?: any;
  handleActionDownload?: (filename: string, href: string) => void;
}

const ProtectedDownloadCustom: React.FC<IParams> = ({
  sourceType,
  sourceId,
  contentId,
  children,
  hasLoaderModal,
  handleActionDownload,
  style,
}) => {
  const rootStore = useContext(RootStoreContext);
  const {
    theme,
    loadDownloadableFile,
  } = rootStore.commonStore;
  const [showModal, setShowModal] = useState(false);
  const [downloadCompleted, setDownloadCompleted] = useState(false);
  const link = useRef<HTMLAnchorElement | null>(null);

  const getFileName = (response: AxiosResponse<any> | undefined) => {
    let filename = "download";
    if (response && response.headers) {
      const disposition = response.headers["content-disposition"];
      if (disposition && disposition.indexOf("attachment") !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
        }
      }
    }
    return filename;
  };

  const handleAction = async () => {
    setShowModal(true);

    if (link.current!.href && downloadCompleted) {
      setShowModal(false);
      setDownloadCompleted(false);
      return;
    }

    link.current!.removeAttribute("href");
    link.current!.removeAttribute("download");
    const result = await loadDownloadableFile(`/content/${sourceType}/${sourceId}/download/${contentId}`);
    if (result && result.data && result.headers && link && link.current) {
      setDownloadCompleted(true);
      const filename = getFileName(result);

      const file = new File([result!.data], filename);
      console.log(file)
      const href = window.URL.createObjectURL(file);
      console.log(href)

      if(handleActionDownload){
        handleActionDownload(filename, href);
        setShowModal(false);
        setDownloadCompleted(false);
      }else{
        link.current!.download = filename;
        link.current!.href = href;
        link.current!.click();
    }
    } else {
      toast.error("file_not_found");
      setShowModal(false);
      setDownloadCompleted(true);
  }   };
 
  return (
    <>
      <a role="button" href="/#" ref={link} onClick={handleAction} style={style? style : {}}>
        {children}
      </a>
      {hasLoaderModal && (
        <GenericModal
          isOpen={showModal}
          size="sm"
          title={""} 
          toggle={() => {}}
          content={
            <>
              <Alert
                color={theme ? theme.loaderColor : "red"}
                className="text-center mb-0"
              >
                <div className="mb-2">{"downloading"}</div>
                <Spinner color="white" />
              </Alert>
            </>
          }
        />
      )}
    </>
  );
};

export default ProtectedDownloadCustom;
